import { useState, useEffect } from "react";
import axios from "axios";

const API = "https://silat.mazenaldaher.com/server"; // Change to your domain

function App() {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState("");

  // Fetch tasks on component mount
  useEffect(() => {
    fetchTasks();
  }, []);

  // Fetch tasks from the server
  const fetchTasks = async () => {
    try {
      const res = await axios.get(`${API}/get_tasks.php`);
      console.log("Response:", res.data); // Log the response to see the data

      // Check if the response data is an array
      if (Array.isArray(res.data)) {
        setTasks(res.data);
      } else {
        console.error("Received data is not an array:", res.data);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  // Add a new task
  const addTask = async () => {
    if (!newTask) return;

    try {
      await axios.post(`${API}/add_task.php`, { task: newTask });
      setNewTask(""); // Reset the input field
      fetchTasks(); // Refresh the tasks list
    } catch (error) {
      console.error("Error adding task:", error);
    }
  };

  // Delete a task
  const deleteTask = async (id) => {
    try {
      await axios.post(`${API}/delete_task.php`, { id });
      fetchTasks(); // Refresh the tasks list
    } catch (error) {
      console.error("Error deleting task:", error);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Simple Task App</h2>
      <input
        value={newTask}
        onChange={(e) => setNewTask(e.target.value)}
        placeholder="Enter new task"
      />
      <button onClick={addTask}>Add</button>

      <ul>
        {tasks.map((task) => (
          <li key={task.id}>
            {task.task}{" "}
            <button onClick={() => deleteTask(task.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default App;
